import { deepFlattenConfig } from '../../../util/form-builder.utils.js';

/**
 * Traverse all the form configuration object and creates an array of data fields, one for each
 * data field needed in the form model
 *
 * @param formConfig The form configuration object
 * @returns an array containing IModelField items, one for each data field.
 */
var getInitialState = function (formConfig) {
    return deepFlattenConfig(formConfig)
        .filter(function (component) { return component.isDataField === true; })
        .map(function (component) { return ({
        id: component.id,
        type: component.type,
        value: null,
        touched: false,
        error: undefined,
        isValid: null,
        isValidationPending: false,
    }); });
};
function trimWhitespace(value) {
    return value.replace(/\s+/g, ' ').trim();
}

export { getInitialState, trimWhitespace };
